// extracted by mini-css-extract-plugin
module.exports = {"render":"LearningOutcome_render__1ptk3","currentPageButton":"LearningOutcome_currentPageButton__14_tk","nextPageButton":"LearningOutcome_nextPageButton__2hvuP"};